import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen" }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

definePageMeta({
  layout: 'public',
  auth: false,
})

const route = useRoute()
const router = useRouter()
const { redirectByToken } = useLegacyQrRedirect()

onMounted(async () => {
  const legacyToken = route.query.id as string | undefined

  if (!legacyToken) {
    await router.replace('/admin/dashboard')
    return
  }

  await redirectByToken(legacyToken)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "text-center" }, [
      _createElementVNode("div", { class: "spinner" }),
      _createElementVNode("p", { class: "mt-4 text-gray-600" }, "Redirecting...")
    ], -1)
  ]))]))
}
}

})